import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Payment} from '../../graphql/payments.datatypes';

interface PaymentData {
    payment: Payment
}

export const gqlPayment = `
    id
    billing_party_member_id
    amount
    billing_party_amount
    timestamp
    payment_type
    payment_status
    provider_reference
    provider_status
    provider_response_raw
    reconciled
    assignedAmount
    description
    refunds_amount

    billingPartyMember {
        id
        billing_party_id
        is_group_leader
        first_name
        last_name
        email
    }

    groupMemberPayments {
        id
        group_member_id
        amount
        groupMember {
            first_name
            last_name
        }
    }
`;

export const GET_PAYMENT_QUERY = gql`
    query getPayment($id: Int!){
        payment(id: $id){
          ${gqlPayment}
        }
    }
`;

export const getPayment = (id: number) => {
    return useQuery<PaymentData>(
        GET_PAYMENT_QUERY,
        {
            variables: {id},
        }
    );
};

export default getPayment;
